import { StripesConnectedSource, } from "@folio/stripes/smart-components";
var DEFAULT_FAILURE_MESSAGE = "Error loading data";
export var createStripesSource = function (_a) {
    var ky = _a.ky, data = _a.data, totalRecords = _a.totalRecords, isLoading = _a.isLoading, isError = _a.isError, isLoaded = _a.isLoaded, fetchMore = _a.fetchMore, _b = _a.failureMessage, failureMessage = _b === void 0 ? DEFAULT_FAILURE_MESSAGE : _b;
    var source = new StripesConnectedSource({}, ky);
    source.update = function () { };
    source.records = function () { return data; };
    source.resultCount = function () { return totalRecords; };
    source.totalCount = function () { return totalRecords; };
    source.pending = function () { return isLoading; };
    source.loaded = function () { return isLoaded; };
    source.failure = function () { return (isError ? { message: failureMessage } : null); };
    source.failureMessage = function () { return failureMessage; };
    source.successfulMutations = function () { return []; };
    source.fetchMore = function () { return fetchMore; };
    return source;
};
